// extracted by mini-css-extract-plugin
export default {"wrapper":"tO-z","ratingContainer":"uO-z","ratingValue":"vO-z","starSprite":"wO-z","ratingLabel":"xO-z","error":"yO-z","errorBox":"zO-z"};